var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcNotificationCalendarCleaned = function SvgIcNotificationCalendarCleaned(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 6h12V4c0-.737-.597-1.333-1.333-1.333H3.333C2.597 2.667 2 3.263 2 4v2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.667 1.333v1.334m0 1.333V2.667M5.333 1.333v1.334m0 1.333V2.667M2 4c0-.737.597-1.333 1.333-1.333h2M2 4v8.667C2 13.403 2.597 14 3.333 14h9.334c.736 0 1.333-.597 1.333-1.333V4M2 4v2h12V4m0 0c0-.737-.597-1.333-1.333-1.333h-2m0 0H5.333"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcNotificationCalendarCleaned);
export default ForwardRef;